/* eslint-disable max-len */
export default Object.freeze({
  SHOPPING_LIST_NOT_FOUND: 'Shopping list does not exist',
  PRODUCT_NOT_FOUND: 'Product does not exist',
  SHOPPING_LIST_ALREADY_EXISTS: 'Oh no, double trouble: you already have a list with the same name. Please try something different.',
  SHOPPING_LISTS_LIMIT_EXCEEDED: 'The maximum number of shopping lists exceeded.',
  SHOPPING_LIST_ITEMS_LIMIT_EXCEEDED: 'The maximum number of items in a shopping list exceeded.',
  UNAUTHORIZED: 'Unauthorized request',
});
